<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Ae6wF8/tc-custom/9783989734012.jpg?1731055227492" alt="This image is the cover for the book The Freelands, CLASSICS TO GO"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Freelands, CLASSICS TO GO
      </h1>
      <p class="bookDescription body article font2">
        <p>In "The Freelands," John Galsworthy crafts a compelling narrative that intertwines the lives of the Freeland family with the social and political upheavals of early 20th-century England. As they navigate the complexities of love, duty, and societal expectations, the Freelands find themselves at the heart of a struggle between tradition and progress. Galsworthy's masterful storytelling captures the essence of an era marked by change, exploring themes of individual freedom, social justice, and the relentless march of time. This timeless tale resonates with contemporary readers, reflecting ongoing debates about equality, human rights, and the balance between personal ambition and collective responsibility. "The Freelands" is a poignant reminder of the enduring human spirit and the ever-relevant quest for a just and compassionate society.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Galsworthy
      </h2>
      
      <p class="authorDescription body article">John Galsworthy (1867-1933) was an English novelist and playwright whose works offer a penetrating critique of the British class system during the late 19th and early 20th centuries. Born into a wealthy family, Galsworthy initially pursued a career in law but soon turned to writing, driven by a passion for social reform and justice.<br>Galsworthy's literary career is most celebrated for "The Forsyte Saga," a series of novels and stories that chronicle the lives of an upper-middle-class family over several generations. This epic work delves into themes of social change, property, and the complexities of human relationships, capturing the zeitgeist of a rapidly evolving society.<br>A staunch advocate for social justice, Galsworthy used his platform to address issues such as workers' rights, women's suffrage, and animal welfare. His plays, like "Justice" and "Strife," were instrumental in highlighting the harsh conditions faced by the working class and contributed to significant legal reforms in Britain.<br>Galsworthy's influence extended beyond literature; he was a founding member of PEN International, an organization dedicated to promoting literature and defending freedom of expression. His commitment to social causes and his nuanced portrayal of societal issues earned him the Nobel Prize in Literature in 1932.<br>Despite his success, Galsworthy's works were not without controversy. His candid exploration of infidelity, materialism, and moral dilemmas often challenged the conservative norms of his time, provoking both admiration and criticism.<br>Galsworthy's legacy endures, inspiring contemporary writers to tackle social issues with the same fervor and integrity. His ability to blend rich storytelling with incisive social commentary makes his works resonate with modern readers, offering timeless insights into the human condition.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ed89b03